import dayjs from 'dayjs';
import { useState, useCallback, useEffect } from 'react';
import isFeatureEnabled from './isFeatureEnabled';

const useServerTime = isFeatureEnabled('sync-server-time');
const debug = 0; // Don't commit this turned on

let ts;

if (useServerTime) {
  const script = document.createElement('script');

  script.onload = function () {
    ts = window['timesync'].create({
      server: `https://vgnpvrqq6me5nibag4loxocxtq0obfrn.lambda-url.us-east-1.on.aws/`,
    });

    if (process.env.NODE_ENV === 'development') {
      ts.on('change', function (offset) {
        console.log('offset from system time:', offset, 'ms');
      });
    }
  };

  script.src = `${process.env.PUBLIC_URL}/timesync.min.js`;
  script.crossOrigin = 'anonymous';

  document.head.appendChild(script);
}

const parts = ['days', 'hours', 'minutes', 'seconds'];
const partsLabels = ['days', 'hours', 'min', 'sec'];

// Global management for all countdowns
const activeCountdowns = [];

let rafId = null;

function rafLoop() {
  activeCountdowns.forEach(c => c.update());
  rafId = window.requestAnimationFrame(rafLoop);
}

function startRAF() {
  if (rafId === null) {
    rafId = window.requestAnimationFrame(rafLoop);
  }
}

function stopRAF() {
  if (activeCountdowns.length === 0 && rafId !== null) {
    window.cancelAnimationFrame(rafId);
    rafId = null;
  }
}

export default function useCountdown(to, pause = false) {
  const [duration, setDuration] = useState(dayjs.duration(0));

  const getTime = () => {
    return new Date(useServerTime && ts ? ts.now() : Date.now());
  };

  const update = useCallback(() => {
    const now = getTime();

    if (debug) console.log('update', now);

    if (new Date(to) <= now) {
      setDuration(dayjs.duration(0));
    } else {
      setDuration(dayjs.duration(dayjs(to).diff(dayjs())));
    }
  }, [to]);

  useEffect(() => {
    const countdownObj = { update };
    activeCountdowns.push(countdownObj);
    startRAF();

    // Always update when deps change
    update();

    return () => {
      // Remove from activeCountdowns
      const idx = activeCountdowns.indexOf(countdownObj);
      if (idx !== -1) activeCountdowns.splice(idx, 1);
      stopRAF();
    };
  }, [to, update]);

  const countdown = {};

  parts.forEach((part, i) => {
    if (pause) {
      countdown[partsLabels[i]] = '--';
    } else {
      const val = duration[part]();
      countdown[partsLabels[i]] = val < 10 ? `0${val}` : val;
    }
  });

  return countdown;
}
